<template>
  <div class="request-box">
    <div v-if="tempData">
      <div class="box1">
        <div class="item">
          <dropdown-calendar-type-2
            v-model="tempData.date"
          ></dropdown-calendar-type-2>
        </div>
        <div class="item">
          <dropdown-time-type-2
            v-model="tempData.reservation"
          ></dropdown-time-type-2>
        </div>
        <div class="item">
          <div class="title">Ref No.</div>
          <div class="text" v-text="tempData.id"></div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="tempMode" class="message-box">
          <div class="input-item">
            <h3>Tell us resaon why you decline this request</h3>
            <dropdown-menu-type-3
              :data="declineMessage"
              v-model="declineMessageKey"
            ></dropdown-menu-type-3>
          </div>
          <div class="buttons">
            <button class="decline" @click="tempMode = false">CANCEL</button>
            <button class="accept" @click="confirm">CONFIRM</button>
          </div>
        </div>
        <div v-else class="message-box">
          <div class="profile-image">
            <img v-imageLoading="tempData.userProfileImage" />
          </div>
          <div class="contents">
            <div class="author">
              Shooting with
              <span class="name" v-text="tempData.userName"></span>
            </div>
            <div
              class="comment"
              v-text="tempData.location.address.detail"
            ></div>
          </div>
          <div class="buttons">
            <button class="decline" @click="tempMode = true">DECLINE</button>
            <button class="accept" @click="accept">ACCEPT</button>
          </div>
        </div>
      </transition>
    </div>
    <div class="no-data" v-else>
      <div class="message">There is no Message</div>
    </div>
  </div>
</template>

<script>
import DropdownCalendarType2 from './DropdownCalendarType2'
import DropdownTimeType2 from './DropdownTimeType2'
import DropdownMenuType3 from './DropdownMenuType3'
import { updateRequestReservation } from '../../api/reservation'
import mixCommon from '../../mixin/common'

export default {
  mixins: [mixCommon],
  name: 'request-box',
  components: {
    DropdownMenuType3,
    DropdownTimeType2,
    DropdownCalendarType2
  },
  props: {
    data: {
      default: () => ({
        date: '04-01-2018',
        time: '1:4',
        refNo: '213',
        profileImage: require('../../assets/images/common/temp-profile.jpg'),
        comment:
          'at Chantrey House, 98 Buckingham Palace Rd, Belgravia, London SW1W 0SS',
        photographerName: 'Miky'
      }),
      type: Object
    },
    mode: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      tempData: {},
      tempMode: false,
      declineMessage: {
        1: {
          title: 'Just'
        },
        2: {
          title: 'Busy'
        }
      },
      declineMessageKey: '1'
    }
  },
  created() {
    this.tempData = this.data
    this.tempMode = this.mode
    this.tempData.time = '1:5'
  },
  methods: {
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.tempData })
    },
    confirm() {
      console.log('declineMessageKey:', this.declineMessageKey)
      const updateInfo = {
        declineMessage: this.declineMessage[this.declineMessageKey].title,
        status: 'decline'
      }
      updateRequestReservation(this.data.id, updateInfo).then(res => {
        console.log('decline confirm res:', res)
        this.tempMode = false
        this.$emit('model')
      })
    },
    accept() {
      const updateInfo = {
        status: 'booking'
      }
      updateRequestReservation(this.data.id, updateInfo).then(res => {
        console.log('accept res:', res)
        this.$emit('model')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.request-box {
  border: 1px solid #c8c8c8;
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    .item {
      width: 100%;
      height: 80px;
      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(2) {
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }
  .message-box {
    height: 133px;
    display: flex;
    justify-content: space-between;
    .profile-image {
      width: 131px;
      height: 131px;
      position: relative;
      img {
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100px;
        height: 100px;
      }
    }
    .input-item {
      margin: auto;
      position: relative;
      display: flex;
      flex-flow: column;
      width: 70%;
      h3 {
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        margin: 0 0 5px 0;
      }
    }
    .contents {
      width: 70%;
      margin: 18px 0 18px 0;
      /*border: 1px dotted red;*/
      .author {
        font-weight: 600;
      }

      .comment {
        margin: 10px 0 0 0;
        width: 700px;
        height: 71px;
        /*border: 1px solid red;*/
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .buttons {
      width: 200px;
      /*border: 1px dotted green;*/
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      button {
        width: 150px;
        height: 50px;
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 1px;
        cursor: pointer;
        outline: none;
      }

      .decline {
        background-color: white;
        border: 1px solid #c8c8c8;
        margin: 0 0 10px 0;
        &:active {
          color: #000000;
        }
      }

      .accept {
        border: 0;
        background-color: #000bff;
        color: white;
      }
    }
  }
  .no-data {
    height: 200px;
    position: relative;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
  }
}
</style>
